import { useMemo } from 'react';

import { useBrowserUILanguage } from '@/hooks/useBrowserUILanguage';
import { useLoginUserInfo } from '@/hooks/useLoginUserInfo';

/**
 * ヘッダー > メインメニュー > マニュアルメニュー用 hooks
 *
 * @returns
 */
export const useManualContainer = () => {
  const { language } = useBrowserUILanguage();
  const { manualUrl } = useLoginUserInfo();

  /**
   * マニュアルリンク
   * プラン情報取得APIのレスポンスの値を使用する
   */
  const manualLink = useMemo(
    () => manualUrl[language] || manualUrl.default,
    [language, manualUrl],
  );

  return {
    manualLink,
  };
};
